import {Text} from '@/components-v2/atoms/Text/Text'
import {SelectableList} from '@/components-v2/molecules/SelectableList/SelectableList'
import {useSegmentFolders} from '@/hooks/useSegmentFolders'

/**
 * @typedef {import('@/types/promotionTypes').SegmentDetails} SegmentDetails
 */

/**
 * Content component for displaying and selecting segments organized by folders.
 * @param {{selectedSegments: SegmentDetails[], setSelectedSegments: Function}} props
 */
export const SegmentFolderContent = ({selectedSegments, setSelectedSegments}) => {
  const {
    selectedSegmentFolderId,
    segmentsFoldersItems,
    segmentsItems,
    isLoadingFolders,
    isLoadingSegmentsByFolder,
    onFolderClick,
    onFolderCheckboxChange,
    onSegmentCheckboxChange,
  } = useSegmentFolders({selectedSegments, setSelectedSegments})

  return (
    <div className="flex h-full w-full">
      <div className="h-full w-1/2 overflow-y-auto border-r border-gray-600">
        <SelectableList
          title="Folder"
          items={segmentsFoldersItems || []}
          onItemClick={onFolderClick}
          onCheckboxChange={onFolderCheckboxChange}
          showSearch={true}
          searchPlaceholder="Search folders..."
          selectable={true}
          showSelectedCount={false}
          separateItems={false}
          isLoading={isLoadingFolders}
        />
      </div>
      <div className="w-1/2">
        {!selectedSegmentFolderId ? (
          <div className="flex w-full items-center justify-center">
            <Text>Please select a folder to view segments</Text>
          </div>
        ) : (
          <SelectableList
            title="Segments"
            items={segmentsItems || []}
            onCheckboxChange={onSegmentCheckboxChange}
            showSearch={true}
            searchPlaceholder="Search segments..."
            selectable={false}
            showSelectedCount={false}
            separateItems={true}
            isLoading={isLoadingSegmentsByFolder}
          />
        )}
      </div>
    </div>
  )
}
